import React, { useState } from "react";
import { CataloguePath, exerciseEditPath } from "routes/createContent/paths";
import { ExerciseListItem, useGetExercises } from "routes/createContent/api/useGetExercises";
import { useDeleteExercise } from "routes/createContent/api/useDeleteExercise";
import { CatalogueList, catalogueQuery, useCatalogueListControls } from "routes/createContent/components/CatalogueList";

const positions = ["standing", "sitting", "lying"];

const movements = [
  "flexion",
  "extension",
  "adduction",
  "abduction",
  "internal_rotation",
  "external_rotation",
  "lateral_flexion",
];

const equipments = ["none", "band", "weight", "ball", "chair", "wall", "mat", "stick", "towel"];

type ExercisesProps = {
  pickerMode?: boolean;
  checkedIds?: number[];
  onPickToggle?: (exercise: ExerciseListItem) => void;
  onPreview?: (exerciseId: number) => void;
};

export const Exercises: React.VFC<ExercisesProps> = props => {
  const [selectedPositions, setSelectedPositions] = useState<string[]>([]);
  const [selectedMovements, setSelectedMovements] = useState<string[]>([]);
  const [selectedEquipments, setSelectedEquipments] = useState<string[]>([]);
  const controls = useCatalogueListControls();
  const query = useGetExercises({
    ...catalogueQuery(controls),
    positions: selectedPositions,
    movements: selectedMovements,
    equipments: selectedEquipments,
  });

  return (
    <CatalogueList
      {...props}
      kind="exercise"
      title="Exercises"
      noun="exercise"
      newPath={`${CataloguePath.Exercises}/new`}
      editPath={exerciseEditPath}
      controls={controls}
      query={query}
      deletion={useDeleteExercise()}
      toItem={exercise => ({
        id: exercise.exercise_id,
        name: exercise.name,
        title: exercise.levels[0]?.title ?? "",
        image: exercise.levels[0]?.image_url || exercise.levels[0]?.video_thumbnail_file_url || "",
        target_joints: exercise.target_joints,
        updated_at: exercise.updated_at,
        creator_id: exercise.creator_id,
        rollout: exercise.rollout,
      })}
      extraColumns={[
        { key: "position", label: "Position", width: 130, value: exercise => exercise.levels[0]?.position },
        { key: "movement", label: "Movement", width: 150, value: exercise => exercise.levels[0]?.movement },
      ]}
      extraFilters={[
        { label: "Position", options: positions, value: selectedPositions, onChange: setSelectedPositions },
        { label: "Movement", options: movements, value: selectedMovements, onChange: setSelectedMovements },
        { label: "Equipment", options: equipments, value: selectedEquipments, onChange: setSelectedEquipments },
      ]}
    />
  );
};
